// extracted by mini-css-extract-plugin
export default {"picked_categories":"CategorySelector_picked_categories__jQSlA"};